import { render, staticRenderFns } from "./_CommonDelete.vue?vue&type=template&id=67cb6eb0&scoped=true&"
import script from "./_CommonDelete.vue?vue&type=script&lang=js&"
export * from "./_CommonDelete.vue?vue&type=script&lang=js&"
import style0 from "./_CommonDelete.vue?vue&type=style&index=0&id=67cb6eb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cb6eb0",
  null
  
)

export default component.exports